/**
 * Loads a selected image in the image component, so the user gets to know the image
 * to be uploaded is valid.
 */
var loadFile = function (event) {
    var output = $('.comps-image-container');
    output.css("background", "url('" + URL.createObjectURL(event.target.files[0]) + "')");
    output.css("background-size", "100% 100%");
    output.css("background-repeat", "no-repeat");
    $(".comps-image").fadeTo("fast", 0);
};

var isEmpty = function (obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
};

/**
 * Check if a value is in array
 *
 * @param value
 * @param array
 * @returns {boolean}
 */
var isInArray = function (value, array) {
    return array.indexOf(value) > -1;
};

/**
 * Display a deletion confirmation
 *
 * @param callback
 * @param options
 */
var impersonateConfirm = function (callback, options) {
    MaterialDialog.dialog(
        "Are you sure you want to switch profile?",
        {
            title: "Confirm",
            buttons: {
                close: {
                    className: "",
                    text: "<i class=\"fas fa-times\"></i>"
                },
                confirm: {
                    className: "blue",
                    text: "Ok",
                    callback: function () {
                        if (options) {
                            callback(options);
                        } else {
                            callback();
                        }
                    }
                }
            }
        }
    );
};
var deleteConfirm = function (callback, options) {
    MaterialDialog.dialog(
        "Are you sure you want to continue?",
        {
            title: "Confirm",
            buttons: {
                close: {
                    className: "",
                    text: "<i class=\"fas fa-times\"></i>"
                },
                confirm: {
                    className: "blue",
                    text: "Ok",
                    callback: function () {
                        if (options) {
                            callback(options);
                        } else {
                            callback();
                        }
                    }
                }
            }
        }
    );
};

/**
 * Displays the current time as a toast message
 */
var saveToast = function () {
    var dt = new Date();

    Materialize.toast('Saved at ' + dt.getHours() + ":" + ('0' + dt.getMinutes()).slice(-2) + " " + (dt.getHours() >= 12 ? "PM" : "AM"), 2000);
};

var startLoading = function (attach) {

    var baseUrl = $('body').attr('data-base-url');

    $(attach).LoadingOverlay("show", {
        image: baseUrl + "/assets/img/loading.png",
        imageAnimation: '2500ms rotate_left',
        zIndex: 1002
    });
};

var addTextToLoading = function (key, n) {
        setTimeout(function(){
            var overlay = $('.loadingoverlay');
            if(n > 1) {
                overlay.removeClass(key + '-' + (n-1));
            }
            overlay.addClass(key + '-' + n);
        }, 100 + (n*100/2));

};

var stopLoading = function (detach) {
    $(detach).LoadingOverlay("hide");
};


var setCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

var getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

var eraseCookie = function (name) {
    document.cookie = name + '=; Max-Age=-99999999;';
};

/**
 * Get a parameter from a URL
 *
 * @param name
 * @param url
 * @returns {*}
 */
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}